import { ERFElement } from '../../../enums';
export const FLOW_ENERGY_CONFIG = {
    type: ERFElement.FlowEnergy,
    icon: 'EnergyFlow',
    templates: []
};
//# sourceMappingURL=RFFlowEnergyNode.config.js.map